module.exports = __webpack_public_path__ + "ethiopia.svg?8edd73195249f00942f56b5a539083c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/ethiopia.svg
// module id = 161
// module chunks = 10